import {
  OnInit,
  Component,
  EventEmitter,
  Input,
  Output,
  HostBinding,
} from '@angular/core';

@Component({
  selector: 'mpro-nested-dropdown',
  templateUrl: './nested-dropdown.component.html',
  styleUrls: ['./nested-dropdown.component.scss'],
  host: {
    '[class.disabled]': 'disabled',
    '[class.selected]': 'selected',
  },
})
export class NestedDropdown implements OnInit {
  constructor() {}

  @Input() public title?: string;
  @Input() public options: any[] = [];
  @Input() public placeholder: string = '';
  @Input() public inputValue: string | undefined;
  @Input() public disabled: boolean = false;
  @Input() public showLock: boolean = false;
  @Input() public selected: boolean = false;
  @Input() public dark: boolean = false;
  @Input() public error: boolean = false;
  @Input() public multiSelect: boolean = false;

  @Output() public selectionChanged: EventEmitter<any> = new EventEmitter();
  @Output() toggle: EventEmitter<boolean> = new EventEmitter<boolean>();

  @HostBinding('style.--bgColor') @Input() public bgColor?: string;
  @HostBinding('style.--bgColorHover') @Input() public bgColorHover?: string;
  menuStatus = false;

  public closeWhenClickedOutside(event: Event): void {}

  public onToggle(option?) {
    if (!option) {
      this.menuStatus = !this.menuStatus;
      return;
    }
    option.status = !option.status;
  }

  public ngOnInit(): void {
    if (!this.inputValue && !this.placeholder) {
      this.inputValue = this.options[0];
    }
  }

  public isOptionSelected(selectedName): boolean {
    return !!this.inputValue
      ?.split(', ')
      .find((value) => value === selectedName);
  }

  public onSelect(selected: any) {
    if (selected.disabled) {
      return;
    }

    if (this.multiSelect) {
      this.menuStatus = !this.menuStatus;
      this.selectionChanged.emit(selected);
      return;
    }

    if (this.inputValue !== selected.name) {
      this.menuStatus = !this.menuStatus;
      this.selectionChanged.emit(selected);
      this.inputValue = selected;
    }
  }
}
